import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the scroll position to the top of the page on every route change.
 * Uses an instant jump (not smooth) so a new page always starts at the top
 * immediately, even though the document has smooth scrolling enabled for
 * in-page anchor links.
 */
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return null;
}